import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import assets from 'modules/assets'
import * as actions from 'actions'

class InfoGallery extends Component {
  constructor(props) {
    super(props)

    this.state = {
      infoCamp2016: false,
      isNavigateGallery: false
    }
  }
  componentDidMount() {
  }

  toggleMenu = () => {
    this.props.dispatch(actions.token.infoCamp2016(!this.state.infoCamp2016))
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      infoCamp2016: nextProps.infoCamp2016,
      isNavigateGallery: nextProps.isNavigateGallery
    })
  }
  close = () => {
    this.toggleMenu()
  }
  render() {
    // default menu language is English
    let menu = <div className="slide-out"></div>
    if (this.state.infoCamp2016 && this.state.isNavigateGallery) {
      menu = (
        <div className='menu info-camp-2016 app-body fade-in' style={{'display': 'flex', 'alignItems': 'center'}}>
          <div className='gallery-info-container'>
            <div style={{'textAlign': 'center', 'marginBottom': '15px'}} className='gallery-info-paragraph'>Gakko is a global educational collective that builds spaces, experiences & tools that reclaim the magic of learning.</div>
            <div style={{'textAlign': 'center', 'marginBottom': '15px'}} className='gallery-info-paragraph'>Every summer, Gakko Camps are held in beautiful places around the world. Designed from the ground up by a diverse group of mentors, Gakko Camps emphasize interdisciplinary workshops and global mentorship.</div>
            <div style={{'textAlign': 'center', 'marginBottom': '55px'}} className='gallery-info-paragraph'>Each year, we encourage attendees to document their own personal experiences at camp using photography and the visual arts. This gallery is the result.</div>
            <h5 style={{'textAlign': 'center', 'marginBottom': '55px'}} className='gallery-info-paragraph'><span className="close-menu" onClick={this.toggleMenu}>×</span></h5>
          </div>
        </div>
      )
    }

    return menu
  }
}
InfoGallery.contextTypes = {
}
InfoGallery.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
    infoCamp2016: state.token.infoCamp2016,
    isNavigateGallery: state.token.isNavigateGallery
  }
}

export default connect(mapStateToProps)(InfoGallery)



// WEBPACK FOOTER //
// ./src/components/Gallery/InfoGallery.js